import { EventEmitter, Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ClearSearchService {
  public clearSearchEvent: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() {}

  public handleClearSearchEvent() {
    this.clearSearchEvent.emit(true);
  }
}
